/* eslint-disable no-shadow */
export enum ExternalVehicleStatusEnum {
	active = 'active',
	inactive = 'inactive',
}

export const ExternalVehicleStatusValues = {
	[ExternalVehicleStatusEnum.active]: {
		title: 'Vehiculo Activo',
		color: 'green_300',
	},
	[ExternalVehicleStatusEnum.inactive]: {
		title: 'Vehiculo Inactivo',
		color: 'neutral_600',
	},
};
